module.exports = __webpack_public_path__ + "static/media/data_analyst_use_case_4.3d6cc119.svg";